const HOME_INDICATOR_CLEARANCE = 16;

const readPx = (style: CSSStyleDeclaration, property: string) =>
	Number.parseFloat(style.getPropertyValue(property)) || 0;

export const getCoveredBottom = (scroller: HTMLElement): number => {
	const root = window.getComputedStyle(document.documentElement);
	const inset = readPx(root, "--mobile-bottom-inset");
	const safeArea = readPx(root, "--mobile-safe-area-bottom");
	const padding =
		Number.parseFloat(window.getComputedStyle(scroller).paddingBottom) || 0;
	const nativeBar =
		inset > safeArea ? inset : Math.min(inset, HOME_INDICATOR_CLEARANCE);

	return nativeBar + Math.max(0, padding - inset);
};
